import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import General from "../../components/profile/General";
import Design from "../../components/profile/Design";
import Social from "../../components/profile/Social";
import Financial from "../../components/profile/Financial";
import Documents from "../../components/profile/Documents";
import Privacy from "../../components/profile/Privacy";
//import Embed from "../../components/profile/Embed";

import "../stepper.css";
import "./EditMusician.css";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Heading from "../../components/Heading";
import { ProfileType } from "../../types/enum";

const styles = theme => ({
    root: {
        width: "90%"
    },
    backButton: {
        marginRight: theme.spacing.unit
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    }
});



@inject("templateStore", "profileStore","googleCalendarStore", "instagramStore")
@observer
class EditMusician extends Component {

    componentDidMount = () => {
        this.props.templateStore.setEditProfileActiveStep(0);
        if(this.props.match.params.new === "googlecalendar"){
            const query = new URLSearchParams(this.props.location.search);
            const token = query.get('code')
            this.props.googleCalendarStore.setGoogleCalendarCode(token);
            this.props.templateStore.setEditProfileActiveStep(2);
        }
        else if(this.props.match.params.new === "instagram"){
            const query = new URLSearchParams(this.props.location.search);
            const token = query.get('code')
            this.props.instagramStore.setInstagramCode(token);
            this.props.templateStore.setEditProfileActiveStep(2);
        }
        else if (this.props.history.location.state !== undefined && this.props.history.location.state.value) {
            this.props.templateStore.setEditProfileActiveStep(2);
        }  else if(this.props.match.params.new === "integration"){
            this.props.templateStore.setEditProfileActiveStep(2);
        }else if(this.props.match.params.new === "financial"){
            this.props.templateStore.setEditProfileActiveStep(3);
        }
        else {
            this.props.templateStore.setEditProfileActiveStep(0);
        }
        
    };

    getStepContent(stepIndex) {
        const { profile, currentProfile } = this.props.profileStore;
        const isNewProfile = this.props.match?.params?.new === "new";
        const generalProfileId = isNewProfile ? undefined : profile?.id;
        const otherTabsProfileId = profile?.id;
        switch (stepIndex) {
            case 0:
                return <General type="musician" profileId={generalProfileId}/>;
            case 1:
                return <Design type="musician" profileId={otherTabsProfileId}/>;
            case 2:
                return <Social type="musician" profileId={otherTabsProfileId}/>;
            case 3:
                return <Financial type="musician" profileId={otherTabsProfileId}/>;
            case 4:
              //  return <Insurance type="musician" profileId={otherTabsProfileId}/>;
                return <Documents type="musician" profileId={otherTabsProfileId}/>;
            case 5:
                return <Privacy type="musician" profileId={otherTabsProfileId}/>;

            default:
                return "Uknown stepIndex";
        }
    }

    handleNext = () => {
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
    };

    handleBack = () => {
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    handleReset = () => {
        this.props.templateStore.setEditProfileActiveStep(0);
    };

    handleStepClick = step => () => {
        this.props.templateStore.setEditProfileActiveStep(step);
    };

    render() {
        const { classes, match } = this.props;
        const steps = this.props.templateStore.getSteps("musician");
        const { editProfileActiveStep } = this.props.templateStore;
        const { profile } = this.props.profileStore;
        return (
            <div className="musician-edit-form">
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading
                        title={
                            profile && profile.isCompleted && profile.type === ProfileType.Musician.ordinal
                                ? "Edit Your Personal Profile"
                                : profile && match && match.params && !match.params.new
                                    ? "Edit Your Personal Profile"
                                    : "Create Your Personal Profile"
                        }
                    />
                    <Grid container>
                        <Grid item md={12} xs={12} sm={12} lg={12}>
                            <Hidden smDown>
                                <Stepper nonLinear={profile && profile.isCompleted} activeStep={editProfileActiveStep} alternativeLabel={false}>
                                    {steps.map((label, index) => {
                                        return (
                                            <Step key={label}>
                                                <StepButton onClick={this.handleStepClick(index)}>{label}</StepButton>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Hidden>
                            <Hidden mdUp xsDown>
                                <Stepper nonLinear={profile && profile.isCompleted} activeStep={editProfileActiveStep} alternativeLabel={true}>
                                    {steps.map((label, index) => {
                                        return (
                                            <Step key={label}>
                                                <StepButton onClick={this.handleStepClick(index)}>{label}</StepButton>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Hidden>
                            <Hidden smUp>
                                <Stepper
                                    nonLinear={profile && profile.isCompleted}
                                    activeStep={editProfileActiveStep}
                                    alternativeLabel={false}
                                    className="stepperXs"
                                >
                                    {steps.map((label, index) => {
                                        return (
                                            <Step key={label}>
                                                <StepButton onClick={this.handleStepClick(index)} />
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Hidden>
                            {editProfileActiveStep === steps.length ? (
                                <Paper className="stepperContent">
                                    <Typography className={classes.instructions} component="h3">
                                        All steps completed - you're profile is ready!
                                    </Typography>
                                    <Button onClick={this.handleReset}>Reset</Button>
                                </Paper>
                            ) : (
                                <Paper className="stepperContent">{this.getStepContent(editProfileActiveStep)}</Paper>
                            )}
                        </Grid>
                    </Grid>
                </MainContainer>
            </div>
        );
    }
}

EditMusician.propTypes = {
    classes: PropTypes.object
};
export default withStyles(styles)(EditMusician);
